export default __webpack_public_path__ + "static/media/svg.de994b6c.svg";